/* eslint-disable no-unused-vars */

// import { store } from 'redux/store';

import { getDataPoints } from '@pages/settings/helper';
import { cleanString } from '@utilities/attachments';

export const getStructureData = ({ inputValue, structure, store }) => {
  const { settings, picklists, cache } = store;
  const { picklistsMap, areaHierarchyTreeDataMap = {} } = picklists;
  const { sitesMap = {}, sites: cacheSites = [] } = cache;
  const { siteDisplayFields } = settings.settings;
  const siteHiddenDisplayFields = settings?.hiddenDataPointsForAssets?.site || '';

  const { name, siteId, structureType: type, dataPoints, dataPointsForSearch } = structure;

  const structureDataPointsCombine = [...(dataPointsForSearch || []), ...(dataPoints || [])];

  const site = cacheSites[sitesMap[siteId]] || {};

  const typeName = picklistsMap[type]?.value;

  const title = `${typeName}`;
  const siteTitle = site?.parent
    ? 'View all work at'
    : areaHierarchyTreeDataMap[site?.areaHierarchy || '']?.title || '';

  const dataPointsObject = structureDataPointsCombine.reduce(
    (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
    {}
  );

  const dataPointsForSite = siteDisplayFields
    ? structure?.dataPointsForSite
      ? structure?.dataPointsForSite
      : getDataPoints({ ...site, type: site.siteType }, siteDisplayFields, 'site', picklistsMap)
    : [];

  const siteDataPointsForSearch = siteHiddenDisplayFields
    ? structure?.siteDataPointsForSearch
      ? structure?.siteDataPointsForSearch
      : getDataPoints(
          { ...site, type: site?.siteType },
          siteHiddenDisplayFields,
          'site',
          picklistsMap
        )
    : [];

  const siteDataPointsCombine = [...siteDataPointsForSearch, ...dataPointsForSite];

  const dataPointsObjectFOrSite = siteDataPointsCombine.reduce(
    (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
    {}
  );

  const filterObject = {
    name,
    title,
    siteTitle,
    siteName: site?.name || '',
    ...dataPointsObject,
    ...dataPointsObjectFOrSite
  };

  const cleanInput = cleanString(inputValue);

  if (
    !Object.values(filterObject).some((value) => {
      return cleanString(String(value)).includes(cleanInput);
    })
  )
    return false;

  return true;
};
